export default {"src":"/_next/static/media/ENB.aa921705.svg","height":18,"width":18};